import script from "./CableDepthofBurial.vue?vue&type=script&setup=true&lang=ts"
export * from "./CableDepthofBurial.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__